import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component( {
    selector: 'ridango-simple-list-item',
    templateUrl: './simple-list-item.component.html',
    styleUrls: [ './simple-list-item.component.scss' ]
} )
export class SimpleListItemComponent implements OnInit {

    @Input() item;
    @Input() rclass;
    @Input() isSelected = false;
    @Input() id: string;
    @Output() onItemSelected: EventEmitter<any> = new EventEmitter();

    label = '';

    constructor() { }

    ngOnInit () {
        if ( this.item === Object( this.item ) ) {
            if ( this.item.label ) {
                this.label = this.item.label;
            } else if ( this.item.name ) {
                this.label = this.item.name;
            } else {
                this.label = '-';
            }
        } else {
            this.label = this.item;
        }
    }

    itemSelected () {
        this.onItemSelected.emit( this.item );
    }

}
